<template>
  <div class="box15">
    <pageTitle
      title="在博学谷学习后他们已成功进入<br />Python+大数据开发领域"
    />

    <div class="content">
      <div class="content-top">
        <div class="name">姓名</div>
        <div class="education">学历</div>
        <div class="before">转型前月薪</div>
        <div class="after">转型后月薪</div>
        <div class="unit">就业单位</div>
      </div>

      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in salaryList"
          :key="index"
        >
          <div class="item">
            <div class="name">{{ item.name }}</div>
            <div class="education">{{ item.education }}</div>
            <div class="before">{{ item.before }}</div>
            <div class="after">{{ item.after }}</div>
            <div class="unit">{{ item.unit }}</div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        // swiper配置
        direction: "vertical", // 滑动方向改为垂直
        height: 72, //你的slide高度 强制性 垂直方向生效
        loop: true, //是否循环
        freeMode: true,
        speed: 3000,
        autoplay: {
          delay: 0, // 自动播放的时长
          stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
          disableOnInteraction: false,
        },
        grabCursor: true,
        slidesPerView: "auto",
      },
      salaryList:[
        {
          name: "李**",
          education: "硕士",
          before: "15000",
          after: "20000",
          unit: "深圳**科技股份有限公司",
          up: "33.33"
        },
        {
          name: "谢**",
          education: "本科",
          before: "15000",
          after: "18000",
          unit: "上海**健康科技有限公司",
          up: "20.00"
        },
        {
          name: "何**",
          education: "本科",
          before: "7000",
          after: "13000",
          unit: "广州**股份有限责任公司",
          up: "85.71"
        },
        {
          name: "申**",
          education: "本科",
          before: "0",
          after: "10000",
          unit: "北京**系统工程有限公司",
          up: "-"
        },
        {
          name: "詹**",
          education: "本科",
          before: "10000",
          after: "23000",
          unit: "上海**有限公司",
          up: "130.00"
        },
        {
          name: "王*",
          education: "本科",
          before: "5500",
          after: "16000",
          unit: "中**科技有限责任公司",
          up: "190.91"
        },
        {
          name: "徐**",
          education: "硕士",
          before: "0",
          after: "15000",
          unit: "保密",
          up: "-"
        },

        {
          name: "米**",
          education: "本科",
          before: "0",
          after: "9000",
          unit: "武汉**技术有限责任公司",
          up: "-"
        },

        {
          name: "于**",
          education: "本科",
          before: "6000",
          after: "10650",
          unit: "**泰科技有限公司",
          up: "77.50"
        },
        {
          name: "黄**",
          education: "本科",
          before: "8000",
          after: "15000",
          unit: "深圳**数据科技有限公司",
          up: "87.50"
        },
        {
          name: "韩**",
          education: "本科",
          before: "0",
          after: "7500",
          unit: "中**科技集团有限公司",
          up: "-"
        },
        {
          name: "赵**",
          education: "本科",
          before: "0",
          after: "10075",
          unit: "**南京有限责任公司",
          up: "-"
        },
        {
          name: "赵**",
          education: "硕士",
          before: "5000",
          after: "14000",
          unit: "**有限公司成都分公司",
          up: "180.00"
        },
        {
          name: "招**",
          education: "本科",
          before: "10000",
          after: "14800",
          unit: "上海**佛山分公司",
          up: "48.00"
        },
        {
          name: "武*",
          education: "本科",
          before: "8000",
          after: "10000",
          unit: "**有限公司海淀分公司",
          up: "25.00"
        },
        {
          name: "吴**",
          education: "本科",
          before: "10000",
          after: "14000",
          unit: "**科技有限公司",
          up: "40.00"
        },
        // {
        //   name: "尧**",
        //   education: "本科",
        //   before: "0",
        //   after: "5800",
        //   unit: "**有限公司福州分公司",
        //   up: "-"
        // }
      ],
      
    };
  },
};
</script>

<style lang="less" scoped>
.box15 {
  padding-top: 80px;
  padding-bottom: 40px;
  width: 100%;

  /deep/ .swiper-container-free-mode > .swiper-wrapper {
    -webkit-transition-timing-function: linear; /*之前是ease-out*/
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
    margin: 0 auto;
  }

  .content {
    margin: 50px auto 0;
    width: 690px;
    height: 802px;
    background-color: #ffffff;
    border-radius: 20px;
    box-shadow: 0px 6px 24px 0px #dbefff;
    overflow: hidden;
    .item {
      display: flex;
      align-items: center;
      text-align: center;
      height: 80px;
      background: #ffffff;

      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #24375c;
      box-sizing: border-box;
    }
    .swiper-slide {
      height: 80px;
    }

    .swiper-slide-active {
      .item {
        background-color: rgba(170, 203, 250, 0.1);
        font-family: PingFangSC-Medium;
        font-size: 24px;
        color: #0080ff;
      }
    }

    .name {
      width: 85px;
    }

    .education {
      width: 85px;
    }
    .before {
      width: 160px;
    }
    .after {
      width: 160px;
    }
    .unit {
      padding: 0px 10px;
      width: 200px;
      box-sizing: border-box;
    }

    .content-top {
      display: flex;
      background-color: #00aaff;
      height: 80px;
      box-sizing: border-box;
      div {
        // flex: 1;
        text-align: center;
        line-height: 80px;
        white-space: nowrap;
        font-family: PingFangSC-Medium;
        font-size: 24px;
        font-weight: normal;
        letter-spacing: 0px;
        color: #ffffff;
      }
    }
  }
}
</style>
